module.exports = __webpack_public_path__ + "static/media/homehub_image.9775d2bc.png";